export const APP_ID = '2071758f5d7f371d';
export const REGION = 'us';
export const AUTH_KEY = '7bfca628c8eb7fdcb8b4bba44478814643db00e7';
